import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import PortalReactDOM from "react-dom";
import axios from "axios";
import severUrl from "../../api";

const MLModel = ({ hide, link, features }) => {
    const [predictValue, SetPredictValue] = useState(0)
    const [fvalues, Setfvalues] = useState([])


    useEffect(() => {
        const v = [];
        if (features) {
            for (let i = 0; i < features.length; i++) {
                v.push({ id: i, value: 0 });
            }
            Setfvalues(v)
        }
    }, []);

    const predict = () => {
        var bodyFormData = new FormData();
        const v = [];
        for (let i = 0; i < fvalues.length; i++) {
            v.push(fvalues[i].value);
        }
        bodyFormData.append("features", v);
        axios
            .post(link, bodyFormData)
            .then((response) => response.data)
            .then((data) => {
                SetPredictValue(data.prediction)
            })
    }

    const changeInput = (id, value) => {
        Setfvalues(fvalues.map(el => (el.id === id ? { ...el, value: value } : el)))
    }

    return PortalReactDOM.createPortal(
        <div className="custom-modal-overlay">
            <div
                className="custom-modal-wrapper"
                aria-modal
                aria-hidden
                tabIndex={-1}
                role="dialog"
            >
                <div className="custom-ml-modal">
                    <div className="custom-modal-header">
                        <button
                            type="button"
                            className="modal-close-button"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={hide}
                            style={{
                                width: "fit-content",
                                padding: 0,
                                marginTop: "5px",
                                marginRight: "5px",
                            }}
                        >
                            <svg
                                width="20"
                                height="20"
                                viewPort="0 0 12 12"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ backgroundColor: "transparent" }}
                            >
                                <line
                                    x1="1"
                                    y1="19"
                                    x2="19"
                                    y2="1"
                                    stroke="black"
                                    stroke-width="2"
                                />
                                <line
                                    x1="1"
                                    y1="1"
                                    x2="19"
                                    y2="19"
                                    stroke="black"
                                    stroke-width="2"
                                />
                            </svg>
                        </button>
                    </div>
                    <div className="custom-mlmodel-content">
                        <div>
                            <h4>Try model</h4>
                            <div className="features-container">
                                {features.map((item, i) => (
                                    <>
                                        <div style={{ display: "flex", flexDirection: "column", width: "100%", margin: "5px 0 5px 0" }}>
                                            <p style={{ textAlign: "left", width: "100%" }}>{item}</p>
                                            <input style={{ maxWidth: "100%" }} id={i} placeholder={i} onChange={(e) => changeInput(i, e.target.value)} /></div>
                                    </>
                                ))}</div>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                                <button style={{ margin: "5px", width: "fit-content" }} onClick={() => predict()}>Predict</button>
                                <p style={{ margin: "5px", width: "fit-content" }}>Predicted value: {predictValue}</p></div>
                        </div></div>
                </div>
            </div>

        </div>,
        document.body
    );
};

export default MLModel;